import Vue from 'vue';
import {Dropdown,DropdownItem,DropdownMenu} from 'element-ui'

Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)